export default __webpack_public_path__ + "static/media/white-arrow.07099008.svg";